import {isEmpty} from "@helpers/helpers";

const $businessPermits = {
    'unlicensed': 'ندارد',
    'temporary': 'موقت',
    'permanent': 'دایم',
};

export const getBusinessPermits = (permit = null) => {
    let businessPermits = '';
    if (isEmpty(permit)) {
        businessPermits = $businessPermits;
    } else if (typeof permit === "string" && !isEmpty($businessPermits[permit])) {
        businessPermits = $businessPermits[permit];
    } else if (typeof permit === "object" && permit.length) {
        businessPermits = [];
        for (let item of permit) {
            businessPermits.push($businessPermits[item]);
        }
    }

    return businessPermits;
};